<template>
  <v-client-table
    :data="tableItems"
    :columns="table.columns"
    :options="table.options"
    class="table-default table-default--40"
  >
    <template #h__name><div class="table-default__left">Name</div></template>
    <template #h__short_name><div class="table-default__left">Short name</div></template>
    <template #name="{ row }">
      <router-link
        :to="{ name: 'administrative-legal-entities-detail-licenses', params: { id: row.code } }"
        class="table-default__link-border"
      >
        {{ row.name }}
      </router-link>
    </template>
    <template #short_name="{ row }"><div class="table-default__left">{{ row.short_name }}</div></template>
  </v-client-table>
</template>

<script>
export default {
  name: 'TableLegalEntities',
  props: ['tableItems'],
  data() {
    return {
      table: {
        columns: ['name', 'short_name'],
        options: {
          headings: {
            name: 'Name',
            short_name: 'Short name',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
}
</script>
